<template>
  <v-card>
    <v-row no-gutters>
      <v-col cols="4">
        <v-card-text>
          <v-treeview
            :items="items"
            :search="search"
            :open.sync="open"
            dense
            hoverable
            activatable
            item-key="codice"
            item-text="descrizione"
            :open-on-click="true"
            :return-object="true"
            transition
            @update:active="onItemSelected"
            @update:open="onUpdateOpen"
          >
            <template v-slot:prepend="{ item, open }">
              <v-icon v-if="!item.type" dense>
                {{ open ? "mdi-folder-open" : "mdi-folder" }}
              </v-icon>
              <v-icon v-else dense>
                {{ icons[item.type] }}
              </v-icon>
            </template>
            <template v-slot:append="{ item }">
              <v-btn
                v-if="item.type"
                icon
                @click="onEditItem(item)"
                title="Modifica l'elemento"
                ><v-icon small>mdi-pencil</v-icon></v-btn
              >
              <v-btn
                v-if="item.type"
                icon
                @click.stop="onRemoveFile(item)"
                title="Cancella il file"
                ><v-icon small>mdi-delete</v-icon></v-btn
              >
              <v-btn
                v-if="item.aggiuntaLiberaFile"
                icon
                @click.stop="onNewFileItem(item)"
                title="Aggiungi un file"
                ><v-icon small>mdi-file-document-plus-outline</v-icon></v-btn
              >
              <v-btn
                v-if="item.aggiuntaLiberaCartelle"
                icon
                @click.stop="onNewItem(item)"
                title="Aggiungi una cartella"
                ><v-icon small>mdi-folder-plus-outline</v-icon></v-btn
              >
            </template>
          </v-treeview>
        </v-card-text>
      </v-col>
      <v-col xs="12" sx="12" md="6" xl="6">
        <div class="upload-image">
          <div
            v-if="image.type === 'image/png'"
            class="upload-image__cropper-wrapper"
          >
            <cropper
              ref="cropper"
              class="upload-image__cropper"
              check-orientation
              :src="image.src"
              :default-size="defaultSize"
              :background-wrapper-component="
                $options.components.CustomBackgroundWrapper
              "
            />
            <v-btn
              icon
              class="upload-image__reset-button"
              title="Cancella immagine"
              @click="reset()"
              ><v-icon>mdi-cached</v-icon></v-btn
            >
            <div
              class="upload-image__file-type"
              v-if="image.type && image.type !== '???'"
            >
              <a
                :href="image.src"
                :download="image.name"
                style="color: white"
                title="Scarica il file"
                >{{ image.name }}</a
              ><br />{{ image.type }}
            </div>
          </div>
          <div
            v-if="image.type === 'video/mp4'"
            class="upload-image__cropper-wrapper"
          >
            <video :key="image.src" :width="400" controls>
              <source :src="image.src" :type="image.type" />
            </video>
            <v-btn
              icon
              class="upload-image__reset-button"
              title="Cancella video"
              @click="reset()"
              ><v-icon>mdi-cached</v-icon></v-btn
            >
            <div
              class="upload-image__file-type"
              v-if="image.type && image.type !== '???'"
            >
              <a
                :href="image.src"
                :download="image.name"
                style="color: white"
                title="Scarica il file"
                >{{ image.name }}</a
              ><br />{{ image.type }}
            </div>
          </div>
          <div class="upload-image__buttons-wrapper">
            <button class="upload-image__button" @click="$refs.file.click()">
              <!-- <input ref="file" type="file" accept="image/*, video/*" @change="loadImage($event)" /> -->
              <input
                ref="file"
                type="file"
                accept="image/png, video/mp4"
                @change="loadImage($event)"
              />
              Carica file
            </button>
            <button
              v-if="image.src"
              class="upload-image__button"
              @click="image.type === 'video/mp4' ? salvaVideo() : crop()"
            >
              Salva
            </button>
          </div>
        </div>
      </v-col>
    </v-row>
    <dialog-conferma
      :show="dialogConferma"
      :title="titoloConferma"
      :message="messaggioConferma"
      @dialog-confirm="onConferma"
      @dialog-cancel="dialogConferma = false"
    />
    <v-dialog v-model="dialogEditItem" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Nuovo elemento</v-card-title>
        <v-card-text>
          <v-container dense>
            <v-row
              ><v-col
                ><v-text-field
                  v-model="newItem.descrizione"
                  label="Descrizione"
                  hide-details
                  clearable
                  clear-icon="mdi-close-circle-outline"
                  @keydown.enter="editFileItemSave"
                ></v-text-field></v-col
            ></v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="editFileItemCancel"
            >Annulla</v-btn
          >
          <v-btn color="blue darken-1" text @click="editFileItemSave">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
/*  eslint-disable */
import { v4 as uuidv4 } from "uuid";
import { Cropper } from "vue-advanced-cropper";
import CustomBackgroundWrapper from "./customBackgroundWrapper";
import "vue-advanced-cropper/dist/style.css";
import configurazioni from "@/services/configurazioniService";
import DialogConferma from "@/components/dialogConferma";
const crypto = require("crypto");

function getMimeType(file, fallback = null) {
  const byteArray = new Uint8Array(file).subarray(0, 4);
  let header = "";
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16);
  }
  switch (header) {
    case "89504e47":
      return "image/png";
    case "47494638":
      return "image/gif";
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
      return "image/jpeg";
    default:
      return fallback;
  }
}

export default {
  components: {
    DialogConferma,
    Cropper,
    /* eslint-disable-next-line */
    CustomBackgroundWrapper,
  },
  props: {
    alberaturaAssets: Object,
    codiceTotem: String,
  },
  data(vm) {
    return {
      expanded: true,
      dialogConferma: false,
      dialogEditItem: false,
      editItem: null,
      newItem: {},
      titoloConferma: "",
      messaggioConferma: "",
      onConferma: vm.onRemoveFile,
      itemToDelete: null,
      search: null,
      open: [],
      items: [],
      filesInFolder: [],
      pathId: "",
      icons: {
        html: "mdi-language-html5",
        js: "mdi-nodejs",
        json: "mdi-code-json",
        md: "mdi-language-markdown",
        pdf: "mdi-file-pdf",
        "image/png": "mdi-file-image",
        txt: "mdi-file-document-outline",
        xls: "mdi-file-excel",
        "???": "mdi-file-question",
        "video/mp4": "mdi-file-video-outline",
      },
      daSalvare: false,
      defaultRootItem: {
        id: "",
        codice: "",
        descrizione: "",
        children: [],
      },
      elementoSelezionato: null,
      itemNuoviFile: null,
      forceUpdate: false,
      files: [],
      image: {
        src: null,
        type: null,
        file: null,
      },
    };
  },
  computed: {},
  watch: {
    async alberaturaAssets() {
      this.items.splice(0);
      this.items = this.items.concat(
        this.generaAlberoDir(this.alberaturaAssets)
      );
      // await this.refreshContenuto(this.items)
    },
  },
  mounted() {
    this.items = this.generaAlberoDir(this.alberaturaAssets);
    for (let i = 0; i < 5; i++) {
      console.log(crypto.randomBytes(16).toString("hex"));
    }
  },
  methods: {
    defaultSize({ imageSize, visibleArea }) {
      return {
        width: (visibleArea || imageSize).width,
        height: (visibleArea || imageSize).height,
      };
    },
    async salvaVideo() {
      const info = await configurazioni.getInfoUpload();
      const aggiunti = [];
      this.loading = true;
      const blob = await fetch(this.image.src).then((r) => r.blob());
      const form_data = new FormData();
      const ff = this.image.file;
      form_data.append("attachment_multiple", blob, ff.name);
      const esistente = this.elementoSelezionato;
      let daAggiungere = {
        name: ff.name,
        date: new Date(),
        descrizione: esistente ? esistente.descrizione || "" : "",
        type: ff.type,
        size: ff.size,
        lastModified: ff.lastModifiedDate,
      };
      if (esistente) {
        daAggiungere.codice = esistente.codice;
      }
      daAggiungere.pathFile = `${info.service}/utility/attachments/file/${daAggiungere.codice}?base=${info.base}&totem=${this.codiceTotem}&fn=${ff.name}`;

      aggiunti.push(daAggiungere);
      await configurazioni.uploadRepositoryMultipleFile(
        form_data,
        info.service,
        info.base,
        null,
        null,
        this.codiceTotem,
        daAggiungere.codice
      );
      this.$emit("change", {
        codiceTotem: this.codiceTotem,
        tipo: "updateFile",
        payload: aggiunti,
      });
      setTimeout(async () => {
        this.items = this.generaAlberoDir(this.alberaturaAssets);
        this.previewImage(daAggiungere);
      }, 500);
      this.loading = false;
    },
    async crop() {
      // TODO: Il salvataggio dovrebbe passare per configurazioni e non direttamente verso licenze ...
      const info = await configurazioni.getInfoUpload();
      const { canvas } = this.$refs.cropper.getResult();
      const aggiunti = [];
      canvas.toBlob(async (blob) => {
        this.loading = true;
        const form_data = new FormData();
        const ff = this.image.file;
        form_data.append("attachment_multiple", blob, ff.name);
        const esistente = this.elementoSelezionato;
        let daAggiungere = {
          name: ff.name,
          date: new Date(),
          descrizione: esistente ? esistente.descrizione || "" : "",
          type: ff.type,
          size: ff.size,
          lastModified: ff.lastModifiedDate,
        };
        if (esistente) {
          daAggiungere.codice = esistente.codice;
        }
        daAggiungere.pathFile = `${info.service}/utility/attachments/file/${daAggiungere.codice}?base=${info.base}&totem=${this.codiceTotem}&fn=${ff.name}`;

        aggiunti.push(daAggiungere);
        await configurazioni.uploadRepositoryMultipleFile(
          form_data,
          info.service,
          info.base,
          null,
          null,
          this.codiceTotem,
          daAggiungere.codice
        );

        this.$emit("change", {
          codiceTotem: this.codiceTotem,
          tipo: "updateFile",
          payload: aggiunti,
        });
        setTimeout(async () => {
          this.items = this.generaAlberoDir(this.alberaturaAssets);
          this.previewImage(daAggiungere);
        }, 500);
        this.loading = false;
      }, this.image.type);
    },
    reset() {
      this.image = {
        src: null,
        type: null,
        file: null,
      };
    },
    loadImage(event) {
      const { files } = event.target;
      if (files && files[0]) {
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        const blob = URL.createObjectURL(files[0]);
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = {
            name: files[0].name,
            src: blob,
            type: getMimeType(e.target.result, files[0].type),
            file: files[0],
          };
        };
        reader.readAsArrayBuffer(files[0]);
      }
    },
    previewImage(file) {
      if (file) {
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        fetch(file.pathFile)
          .then((response) => response.blob())
          .then((blob) => {
            const url = URL.createObjectURL(blob);
            this.image = {
              src: url,
              type: file.type,
              file: file,
              name: file.name,
              codice: file.codice,
            };
          });
      }
    },
    generaAlberoDir(alberaturaAssets) {
      // Assumo che l'alberatura degli assets venga creata automaticamente al momento della creazione del totem da licenze
      // Va previsto adeguamento struttura in caso di aggiornamenti del software
      let items = [];
      for (let d of alberaturaAssets.cartelle) {
        let al = {
          codice: d.codice,
          descrizione: d.descrizione,
          aggiuntaLiberaFile: d.aggiuntaLiberaFile,
          aggiuntaLiberaCartelle: d.aggiuntaLiberaCartelle,
        };
        al.children = this.generaAlberoDir(d);
        items.push(al);
      }
      for (let f of alberaturaAssets.files) {
        let al = {
          codice: f.codice || crypto.randomBytes(16).toString("hex"),
          name: f.name,
          descrizione: f.descrizione || f.name,
          type: f.type,
          pathFile: f.pathFile,
        };
        items.push(al);
      }
      return items;
    },
    onRefresh() {
      this.$emit("refresh");
    },
    onRemoveFile(item) {
      this.titoloConferma = "Cancellazione file";
      this.messaggioConferma = "Confermi cancellazione del file ?";
      this.onConferma = this.removeFile;
      this.itemToDelete = item;
      this.dialogConferma = true;
    },
    removeFile() {
      const item = this.itemToDelete;
      this.$emit("change", {
        codiceTotem: this.codiceTotem,
        tipo: "deleteFile",
        payload: item,
      });
      this.itemToDelete = null;
      this.dialogConferma = false;
      setTimeout(async () => {
        this.items = this.generaAlberoDir(this.alberaturaAssets);
        this.reset();
      }, 500);
    },
    async refreshContenuto(el) {
      if (el.children) {
        this.reset();
      } else {
        this.previewImage(el);
      }
    },
    async onItemSelected(elementi) {
      let el = elementi && elementi.length > 0 ? elementi[0] : {};

      if (!_.isEmpty(el)) {
        this.elementoSelezionato = el;
        await this.refreshContenuto(el);
      } else {
        this.elementoSelezionato = null;
      }
    },
    findRecurse(items, codice) {
      var item;
      for (let el of items) {
        console.log(el.codice);
        if (el.codice === codice) {
          item = el;
          item.pathId = el.codice;
        } else {
          if (el.children) {
            item = this.findRecurse(el.children, codice);
            if (item) {
              item.pathId = item.pathId + "." + el.codice;
            }
          }
        }
        if (item) {
          break;
        }
      }
      return item;
    },
    deleteFolder(item) {
      this.titoloConferma = "Cancellazione cartella";
      this.messaggioConferma = "Confermi la cancellazione della cartella ?";
      this.onConferma = this.deleteFolderConfirm;
      this.itemToDelete = item;
      this.dialogConferma = true;
    },
    deleteFolderConfirm() {
      this.forceUpdate = true;
      const foundEl = this.findRecurse(this.items, this.itemToDelete.id);
      const pathId = foundEl.pathId
        .split(".")
        .reverse()
        .join("\\");
      this.$emit("deleteFolder", pathId);
      this.itemToDelete = null;
      this.dialogConferma = false;
    },
    onUpdateOpen(elementi) {
      this.expanded = elementi.length > 0;
    },
    onNewFileItem(item) {
      this.editItem = item;
      this.newItem = {
        codice: crypto.randomBytes(16).toString("hex"),
        descrizione: "",
        name: "",
        pathFile: "",
        type: "???",
      };
      this.dialogEditItem = true;
    },
    onEditItem(item) {
      this.editItem = item;
      this.newItem = item;
      this.dialogEditItem = true;
    },
    editFileItemCancel() {
      this.dialogEditItem = false;
    },
    editFileItemSave() {
      if (this.newItem !== this.editItem) {
        if (!this.newItem.descrizione) {
          this.dialogEditItem = false;
          return;
        }
        this.editItem.children = this.editItem.children || [];
        this.editItem.children.push(this.newItem);
        this.$emit("change", {
          codiceTotem: this.codiceTotem,
          tipo: "addFile",
          payload: [this.newItem],
          codiceItem: this.editItem.codice,
        });
      } else {
        this.$emit("change", {
          codiceTotem: this.codiceTotem,
          tipo: "updateFile",
          payload: [this.editItem],
        });
      }
      this.dialogEditItem = false;
    },
    editDirItemSave() {
      let el = {
        id: uuidv4(),
        codice: this.newItem.codice,
        descrizione: this.newItem.codice,
      };
      this.editItem.children = this.editItem.children || [];
      this.editItem.children.push(el);
      this.dialogEditItem = false;
      this.$emit(
        "createFolder",
        this.editItem.codice + "/" + this.newItem.codice
      );
      this.daSalvare = true;
      // this.onUpdateOpen(this.open)
    },
    async rigaSelezionata(item, data, event) {
      /*       if (item.file === 'dati.json') {
        const elenco = await impostazioni.leggeFileImpostazione(item.dir)
        this.jsonWebS = elenco[0].dati
        this.markdownInfo = elenco[0].info
        this.mostraJson = true
      } else {
        this.mostraJson = false
      } */
    },
    onErrorWeb() {},
  },
  destroyed() {
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src);
    }
  },
};
</script>

<style lang="scss">
.img-canvas {
  width: 500px;
  height: 416px;
}

.cropper {
  background: #943e3e;
  &__image {
    opacity: 1;
  }
}
/* ----------------------------   */
.upload-image {
  margin-top: 20px;
  margin-bottom: 20px;
  user-select: none;

  &__cropper {
    border: solid 1px #eee;
    min-height: 300px;
    max-height: 500px;
    width: 100%;
  }

  &__cropper-wrapper {
    position: relative;
  }

  &__reset-button {
    position: absolute;
    right: 20px;
    bottom: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    width: 42px;
    background: rgba(#3fb37f, 0.7);
    transition: background 0.5s;
    &:hover {
      background: #3fb37f;
    }
  }

  &__buttons-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 17px;
  }

  &__button {
    border: none;
    outline: solid transparent;
    color: white;
    font-size: 16px;
    padding: 10px 20px;
    background: #3fb37f;
    cursor: pointer;
    transition: background 0.5s;
    margin: 0 16px;
    &:hover,
    &:focus {
      background: #38d890;
    }
    input {
      display: none;
    }
  }

  &__file-type {
    position: absolute;
    top: 20px;
    left: 20px;
    background: #0d0d0d;
    border-radius: 5px;
    padding: 0px 10px;
    padding-bottom: 2px;
    font-size: 12px;
    color: white;
  }
}
</style>
